<div class="chatbot-toggle-icon">
  <div class="animate">
    <div class="help-text" *ngIf="showHelpText">
      May I help you?
    </div>
    <img
    style="float: right;"
      [attr.src]="'assets/imgs/' + imgName"
      (click)="toggleChatBot(1)"
      *ngIf="!closeBtnShow"
    />
  </div>

  <!-- <img
    *ngIf="closeBtnShow"
    class="toggle-chatbot"
    [attr.src]="'assets/imgs/endb-close.png'"
    (click)="toggleChatBot(2)"
  /> -->
</div>
